import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import Logo from "@/components/Logo";
import { SERVICES } from "@/data/services";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/pricing", label: "Pricing" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [svcOpen, setSvcOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-brand-border">
      <div className="container-x flex items-center justify-between h-16 lg:h-20">
        <Link to="/" data-testid="nav-home-link" className="shrink-0">
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          <NavLink to="/" end data-testid="nav-link-home" className={({ isActive }) => `text-sm ${isActive ? "text-brand-ink" : "text-brand-muted hover:text-brand-ink"} transition-colors`}>Home</NavLink>

          <div className="relative" onMouseEnter={() => setSvcOpen(true)} onMouseLeave={() => setSvcOpen(false)}>
            <button data-testid="nav-services-trigger" className="flex items-center gap-1 text-sm text-brand-muted hover:text-brand-ink transition-colors">
              Services <ChevronDown className="w-4 h-4" />
            </button>
            {svcOpen && (
              <div className="absolute left-1/2 -translate-x-1/2 top-full pt-3 w-[540px]" data-testid="nav-services-dropdown">
                <div className="bg-white rounded-2xl border border-brand-border shadow-xl p-4 grid grid-cols-2 gap-1">
                  {SERVICES.map((s) => (
                    <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`nav-service-${s.slug}`} className="flex items-start gap-3 p-3 rounded-xl hover:bg-brand-surface transition-colors">
                      <span className="mt-0.5 w-9 h-9 rounded-lg bg-brand-surface flex items-center justify-center">
                        <s.icon className="w-4 h-4 text-brand-ink" />
                      </span>
                      <span>
                        <span className="block font-medium text-sm text-brand-ink">{s.title}</span>
                        <span className="block text-xs text-brand-muted line-clamp-1">{s.tagline}</span>
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          {NAV.slice(1).map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-link-${n.label.toLowerCase()}`} className={({ isActive }) => `text-sm ${isActive ? "text-brand-ink" : "text-brand-muted hover:text-brand-ink"} transition-colors`}>
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/contact" data-testid="nav-cta-contact" className="btn-primary text-sm py-2.5 px-5">Start a Project</Link>
        </div>

        <button onClick={() => setOpen((v) => !v)} data-testid="nav-mobile-toggle" className="lg:hidden p-2 -mr-2">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-brand-border bg-white" data-testid="nav-mobile-menu">
          <div className="container-x py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} data-testid={`nav-mobile-link-${n.label.toLowerCase()}`} className="py-2 text-brand-ink">{n.label}</Link>
            ))}
            <div className="pt-2 border-t border-brand-border mt-2">
              <div className="text-xs uppercase tracking-widest text-brand-muted py-2">Services</div>
              {SERVICES.map((s) => (
                <Link key={s.slug} to={`/services/${s.slug}`} onClick={() => setOpen(false)} data-testid={`nav-mobile-service-${s.slug}`} className="py-2 block text-brand-muted hover:text-brand-ink">{s.title}</Link>
              ))}
            </div>
            <Link to="/contact" onClick={() => setOpen(false)} data-testid="nav-mobile-cta" className="btn-primary mt-3 justify-center">Start a Project</Link>
          </div>
        </div>
      )}
    </header>
  );
}
